import { render, staticRenderFns } from "./Oleo100Curative.vue?vue&type=template&id=2171ad80&scoped=true"
import script from "./Oleo100Curative.vue?vue&type=script&lang=js"
export * from "./Oleo100Curative.vue?vue&type=script&lang=js"
import style0 from "./Oleo100Curative.vue?vue&type=style&index=0&id=2171ad80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171ad80",
  null
  
)

export default component.exports